import {ThemeAllProps, ThemeDirectProps} from '../../types';

export const getDirectThemeToBaseProperties = (
  props: ThemeAllProps,
): ThemeDirectProps => {
  // Consider all properties required, to get type error if introducing a new property not included here
  const allProps = props as Required<ThemeAllProps>;
  const {
    width,
    height,
    minWidth,
    maxWidth,
    minHeight,
    maxHeight,
    raised,
    direction,
    horizontal,
    vertical,
    flex,
    justify,
    align,
    centered,
    alignSelf,
    position,
    absolute,
    top,
    left,
    right,
    bottom,
    zIndex,
    visibility,
    hidden,
    pointerEvents,
    overflow,
  } = allProps;

  const allDirectProps: Required<ThemeDirectProps> = {
    width,
    height,
    minWidth,
    maxWidth,
    minHeight,
    maxHeight,
    raised,
    direction,
    horizontal,
    vertical,
    flex,
    justify,
    align,
    centered,
    alignSelf,
    position,
    absolute,
    top,
    left,
    right,
    bottom,
    zIndex,
    visibility,
    hidden,
    pointerEvents,
    overflow,
  };

  return allDirectProps;
};
